import { StateSetter } from './common';
import { useStateAlt } from './useStateAlt';

export interface WindowParams {
  open?: boolean;
}

export class Window {
  public readonly isOpen: boolean;
  public readonly setOpen: StateSetter<boolean>;

  constructor(params: WindowParams) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    [this.isOpen, this.setOpen] = useStateAlt(params.open, false);
  }

  public toggleOpen(): void {
    this.setOpen(open => !open);
  }

  public open(): void {
    this.setOpen(true);
  }

  public close(): void {
    this.setOpen(false);
  }
}
